import { ShopLinkPostInput } from '../../templates/inputs/ShopLinkPostInput';
import {
    DEFAULT_OPEN_SHOP_ACTION,
    getDefaultButton,
} from '../components/ActionButton';
import { isShopLinkPost } from '../PostTypes';
import { ShopLinkPostData } from '../types/ShopLinkPostData';
import { defineTemplate } from './TemplateUtils';
import { EMPTY_TRANSLATION_TABLE } from '@lifeserver/shared';

export const ShopLinkMedium = defineTemplate(
    'ShopLink',
    'Medium',
    ShopLinkPostInput,
    () =>
        ({
            $type: 'ShopLink',
            size: 'Medium',
            button: getDefaultButton(DEFAULT_OPEN_SHOP_ACTION),
            header: EMPTY_TRANSLATION_TABLE,
        }) satisfies ShopLinkPostData,
    isShopLinkPost,
);
export const ShopLinkLarge = defineTemplate(
    'ShopLink',
    'Large',
    ShopLinkPostInput,
    () =>
        ({
            $type: 'ShopLink',
            size: 'Large',
            button: getDefaultButton(DEFAULT_OPEN_SHOP_ACTION),
            header: EMPTY_TRANSLATION_TABLE,
        }) satisfies ShopLinkPostData,
    isShopLinkPost,
);
